'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _academyLogo = require('bender-url!signup-ui/images/academy-logo.svg');

var _academyLogo2 = _interopRequireDefault(_academyLogo);

var _academyLogoText = require('bender-url!signup-ui/images/academy-logo-text.svg');

var _academyLogoText2 = _interopRequireDefault(_academyLogoText);

var _developersLogo = require('bender-url!signup-ui/images/developers-logo.svg');

var _developersLogo2 = _interopRequireDefault(_developersLogo);

var _contentLogo = require('bender-url!signup-ui/images/content-logo.svg');

var _contentLogo2 = _interopRequireDefault(_contentLogo);

var _logoGoogle = require('bender-url!signup-ui/images/logo-google.png');

var _logoGoogle2 = _interopRequireDefault(_logoGoogle);

var _salesMeetings = require('bender-url!signup-ui/images/sales-meetings-2.png');

var _salesMeetings2 = _interopRequireDefault(_salesMeetings);

var _salesExtension = require('bender-url!signup-ui/images/sales-extension.png');

var _salesExtension2 = _interopRequireDefault(_salesExtension);

var _liveChatEn = require('bender-url!signup-ui/images/live-chat-en.png');

var _liveChatEn2 = _interopRequireDefault(_liveChatEn);

var _leadFlowsEn = require('bender-url!signup-ui/images/lead-flows-en.png');

var _leadFlowsEn2 = _interopRequireDefault(_leadFlowsEn);

var _formsEn = require('bender-url!signup-ui/images/forms-en.png');

var _formsEn2 = _interopRequireDefault(_formsEn);

var _documentsEn = require('bender-url!signup-ui/images/documents-en.png');

var _documentsEn2 = _interopRequireDefault(_documentsEn);

var _crmEmailEn = require('bender-url!signup-ui/images/crm-email-en.png');

var _crmEmailEn2 = _interopRequireDefault(_crmEmailEn);

var _iconGmail = require('bender-url!signup-ui/images/verified/icon-gmail.svg');

var _iconGmail2 = _interopRequireDefault(_iconGmail);

var _iconOutlook = require('bender-url!signup-ui/images/verified/icon-outlook.svg');

var _iconOutlook2 = _interopRequireDefault(_iconOutlook);

var _iconYahoo = require('bender-url!signup-ui/images/verified/icon-yahoo.svg');

var _iconYahoo2 = _interopRequireDefault(_iconYahoo);

var _setupComplete = require('bender-url!signup-ui/images/verified/setup-complete.svg');

var _setupComplete2 = _interopRequireDefault(_setupComplete);

var _hubspotWordmarkLight = require('bender-url!signup-ui/images/hubspot-wordmark--light.svg');

var _hubspotWordmarkLight2 = _interopRequireDefault(_hubspotWordmarkLight);

var _hubspotWordpressLogo = require('bender-url!signup-ui/images/hubspot-wordpress-logo.png');

var _hubspotWordpressLogo2 = _interopRequireDefault(_hubspotWordpressLogo);

var _getStaticAsset = require('./getStaticAsset');

var _marketingFreeEmailEn = require('bender-url!signup-ui/images/internationalized-marketing-email/marketing-free-email-en.png');

var _marketingFreeEmailEn2 = _interopRequireDefault(_marketingFreeEmailEn);

var _marketingFreeEmailEs = require('bender-url!signup-ui/images/internationalized-marketing-email/marketing-free-email-es.png');

var _marketingFreeEmailEs2 = _interopRequireDefault(_marketingFreeEmailEs);

var _marketingFreeEmailDe = require('bender-url!signup-ui/images/internationalized-marketing-email/marketing-free-email-de.png');

var _marketingFreeEmailDe2 = _interopRequireDefault(_marketingFreeEmailDe);

var _marketingFreeEmailJa = require('bender-url!signup-ui/images/internationalized-marketing-email/marketing-free-email-ja.png');

var _marketingFreeEmailJa2 = _interopRequireDefault(_marketingFreeEmailJa);

var _marketingFreeEmailPt = require('bender-url!signup-ui/images/internationalized-marketing-email/marketing-free-email-pt.png');

var _marketingFreeEmailPt2 = _interopRequireDefault(_marketingFreeEmailPt);

var _marketingFreeEmailFr = require('bender-url!signup-ui/images/internationalized-marketing-email/marketing-free-email-fr.png');

var _marketingFreeEmailFr2 = _interopRequireDefault(_marketingFreeEmailFr);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IMAGES = {
  developersLogo: _developersLogo2.default,
  academyLogo: _academyLogo2.default,
  academyLogoText: _academyLogoText2.default,
  contentLogo: _contentLogo2.default,
  googleLogo: _logoGoogle2.default,
  meetingsImage: _salesMeetings2.default,
  salesExtensionImage: _salesExtension2.default,
  liveChatImage: _liveChatEn2.default,
  leadflowsImage: _leadFlowsEn2.default,
  formsImage: _formsEn2.default,
  documentsImage: _documentsEn2.default,
  crmEmailImage: _crmEmailEn2.default,
  hubspotLogoWhite: _hubspotWordmarkLight2.default,
  hubspotLogo: (0, _getStaticAsset.fromSalesImages)('logos/hubspot-standard.svg'),
  appleStore: (0, _getStaticAsset.fromSalesImages)('icons/apple-store.png'),
  googlePlayStore: (0, _getStaticAsset.fromSalesImages)('icons/google-play-store.png'),
  createSuccess: (0, _getStaticAsset.fromSalesImages)('icons/success-orange-simple.svg'),
  lock: (0, _getStaticAsset.fromSalesImages)('icons/lock.svg'),
  airBalloon: (0, _getStaticAsset.fromSalesImages)('onboarding/air-balloon.svg'),
  iceCream: (0, _getStaticAsset.fromSalesImages)('errors/icecream.svg'),
  salesTools: (0, _getStaticAsset.fromSalesImages)('onboarding/salesTools/bundle.svg'),
  gmailLogo: _iconGmail2.default,
  yahooLogo: _iconYahoo2.default,
  outlookLogo: _iconOutlook2.default,
  setupComplete: _setupComplete2.default,
  marketingFreeEmailImage: _marketingFreeEmailEn2.default,
  hubspotWordpressLogo: _hubspotWordpressLogo2.default
};

var INTERNATIONALIZED_IMAGES = {
  marketingFreeEmailImage: {
    es: _marketingFreeEmailEs2.default,
    de: _marketingFreeEmailDe2.default,
    ja: _marketingFreeEmailJa2.default,
    fr: _marketingFreeEmailFr2.default,
    pt: _marketingFreeEmailPt2.default,
    en: _marketingFreeEmailEn2.default
  }
};

exports.default = {
  get: function get(key) {
    this.preload(key);

    if (key && IMAGES.hasOwnProperty(key)) {
      return IMAGES[key];
    }

    return IMAGES;
  },
  getInternationalized: function getInternationalized(key, locale) {
    if (key && INTERNATIONALIZED_IMAGES[key].hasOwnProperty(locale)) {
      return INTERNATIONALIZED_IMAGES[key][locale];
    }
    return INTERNATIONALIZED_IMAGES[key]['en'];
  },


  preload: function preload(key) {
    var image = IMAGES[key];
    var preloadedImage = new Image();
    preloadedImage.src = image;
    return preloadedImage;
  }
};
module.exports = exports['default'];